export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this digital or physical?',
    answer:
      'Completely digital. Instant access to PDFs, videos, and backing tracks. Print anything you want.',
  },
  {
    question: "Will this work for my students' skill level?",
    answer:
      'Yes. The system scales from absolute beginner through advanced. All materials are modular and adaptable.',
  },
  {
    question: 'Can I customize the lessons for my students?',
    answer:
      'Absolutely. Every lesson is editable and designed to be personalized to your specific teaching context.',
  },
  {
    question: 'How do I access the material?',
    answer:
      'Instant download after checkout. Everything arrives in your email within 2 minutes.',
  },
  {
    question: "What if I'm not completely satisfied?",
    answer: '7-day money-back guarantee. No questions. Full refund.',
  },
]
